<template>
  <v-app>
    <router-view>
    </router-view>
  </v-app>
</template>

<script>
const fb = require('@/firebase')

const rootUrl = 'https://https://fanmosaic.fox/'
const oktaDomain = 'myfox'
let functionsUrl
if (process.env.VUE_APP_USE_FIREBASE_EMULATORS) {
  functionsUrl = 'http://localhost:5555/foxsports-fanmosaic-prod/us-central1'
} else {
  functionsUrl = 'https://us-central1-foxsports-fanmosaic-prod.cloudfunctions.net'
}
console.log(`Using functions URL: ${functionsUrl}`)

import axios from 'axios'

export default {
  name: 'App',

  components: {
  },

  data: () => ({
  }),

  computed: {
    authenticated () {
      return this.$store.state.authenticated
    },
    fbAuthenticated () {
      return this.$store.state.fbAuthenticated
    }
  },

  mounted () {
    this.$root.$on('logout', () => {
      this.logout()
    })
  },

  methods: {
    // Check for Okta authorization
    async authCheck () {
      console.log('Running auth check.')
      this.$store.commit('setAuthenticated', await this.$auth.isAuthenticated())

      if (this.authenticated) {
        const claims = await this.$auth.getUser()

        if (claims) {
          console.log(`Got Okta user: ${claims.sub}`)

          if (!this.fbAuthenticated) {
            this.firebaseLogin(claims.sub)
          } else {
            console.log('The Firebase user is already authenticated.')
          }
        } else {
          console.log('No Okta user present.')
        }
      }
    },

    // Login to Firebase using custom token generated through Cloud Functions
    firebaseLogin (uid) {
      console.log('Attempting login for Firebase user.')

      // Make a post request to the Cloud Functions endpoint to generate token, using the Okta UID as an argument
      axios.post(`${functionsUrl}/authorize`, null, {
        params: {
          id: uid
        }
      }).then((res) => {
        console.log('Signing in with custom token.')

        fb.auth.signInWithCustomToken(res.data).then((res) => {
          const uid = res.user.uid
          console.log(`Signed ${uid} into Firebase with custom token.`)

          const targetPage = this.$route.query.target || 'stories'
          console.log(`Target Page: ${targetPage}`)
          if(this.$route.path == '/') {
            this.$router.push(`${targetPage}`)
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    async logout () {
      await fb.auth.signOut()

      if (this.authenticated) {
        const idToken = await this.$auth.getIdToken()
        this.$auth.logout()
        window.location.href = `https://${oktaDomain}.okta.com/oauth2/default/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${rootUrl}`
      }
    }
  },

  watch: {
    $route () {
      this.authCheck()
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: $font-body;
  background-color: black;

  .theme--light.v-application.dark {
    background: black;
  }

  &.story {
    @include fill-screen;
    overflow: hidden;
  }

  // STORY SPECIFIC
  &.studio-shows {
    .theme--light.v-application.dark {
      background: $ss-purple-dark;
    }
  }

  &.betting {
    @import '@/assets/style/story-specific/betting';
  }

  &.nascar {
    @import '@/assets/style/story-specific/nascar';
  }

  &.nfl-female-fans {
    @import '@/assets/style/story-specific/nfl-female-fans';
  }

  &.mlb {
    @import '@/assets/style/story-specific/mlb';
  }

  &.world-cup {
    @import '@/assets/style/story-specific/world-cup';
  }

  &.login {
    .v-application {
      background-color: $brand-dark;
    }
  }

  &.stories {
    .v-application {
      background-color: $brand-dark-blue;
      color: $brand-light-blue;
    }
  }

  // When nav is shown on mobile, don't allow pointer events on the body (iOS fix)
  @include media($bp-phone-l) {
    &.nav-shown {
      pointer-events: none;

      .story-nav, .hamburger {
        pointer-events: auto;
      }
      .story-nav {
        -webkit-overflow-scrolling: touch;
      }
    }
  }
}

h1 {
  font-family: $font-display;
}

h2 {
  font-family: $font-title;
}

button {
  outline: none;
}

.ProseMirror {
  &:focus {
    outline: none;
  }
}

.slick-slide {
  font-size: 0;
}

.slick-current {
  z-index: $z-active-slide;
}

.slick-list {
  background-size: cover;
  -webkit-background-size: cover;
  background-position: center center;
}

.v-btn.login-button .v-btn__content {
  transform: translateY(-2px);
  @include media($bp-tablet) {
    transform: translateY(-1px);
  }
}

.logout {
  z-index: $z-logout;
  display: inline-block;
  text-transform: uppercase;
  font-family: $font-display;
  font-size: $font-size-xs;
  background-color: white;
  border-radius: 8px;
  padding: 4px $space-ms;
}

.hamburger {
  cursor: pointer;
  z-index: $z-hamburger;
  position: fixed;
  top: $space-ml;
  left: $space-ml;

  @include media-wh($bp-tablet, $hbp-tablet) {
    top: $space-s;
    left: $space-s;
  }

  .hitbox {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: $space-m;
    height: $space-m;
  }

  .icon {
    position: relative;
    width: $space-m;
    height: 25px;
    > div {
      position: absolute;
      width: 100%;
      right: 0;
      height: 3px;
      background-color: $brand-grey-transparent;

      transition: .3s all;

      &:nth-child(1) {
        top: 0;
        transform-origin: right top;
      }
      &:nth-child(2) {
        top: 50%;
        transform: translateY(-2px);
      }
      &:nth-child(3) {
        bottom: 0;
        transform-origin: right bottom;
      }
    }

    &.close {
      > div {
        &:nth-child(1) {
          transform: rotateZ(-34deg);
        }
        &:nth-child(2) {
          width: 0;
        }
        &:nth-child(3) {
          transform: rotateZ(34deg);
        }

        transition: .3s all;
      }
    }

    @include media-wh($bp-phone-l, $hbp-phone-l) {
      height: 14px;
      width: 20px;
      > div {
        height: 2px;
        &:nth-child(2) {
          transform: translateY(-1px);
        }
      }
      &.close {
      > div {
        &:nth-child(1) {
          transform: rotateZ(-38deg);
        }
        &:nth-child(3) {
          transform: rotateZ(38deg);
        }
      }
    }
    }
  }
}

.studio-shows .story-wrapper.dark-theme {
  background-color: $ss-purple-dark;

  .story-cover {
    h2 {
      font-weight: 300;
      font-family: $font-title-regular;
      strong {
        font-family: $font-title-heavy;
      }
    }
  }

  .story-nav {
    .nav-subtitle h2 {
      strong {
        font-family: $font-title-heavy;
      }
    }
  }

  .title {
    h1 {
      strong {
        font-family: $font-title-heavy;
      }
    }
  }

  .story-beat.text {
    em {
      color: $ss-orange;
      font-style: normal;
    }
  }
}

.story-wrapper.dark-theme {
  background-color: black;
  color: white;
  .hamburger {
    .icon > div {
      background-color: $white-transparent;
    }
  }
}
.story-wrapper.white-ui {
  .hamburger .icon > div {
    background-color: $white-transparent;
  }
}

.betting, .world-cup {
  .hamburger .icon.close > div {
    background-color: $brand-grey-transparent;
  }
}

.global-loader {
  z-index: $z-loader;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $brand-dark-blue;

  .v-progress-circular {
    @include center-in-parent;
  }
}

/** Animations */
@keyframes expand {
  0% {
    transform: scale(1.0, 1.0);
  }
  50% {
    transform: scale(1.05, 1.0) translateX(0);
  }
  100% {
    transform: scale(1.0, 1.0);
  }
}
@keyframes contract {
  0% {
    transform: scale(1.0, 1.0);
  }
  50% {
    transform: scale(0.95, 1.0) translateX(0);
  }
  100% {
    transform: scale(1.0, 1.0);
  }
}

/**
  * Custom Tiptap components
  * Shared between ArticleBuilder and Article
  */

// TOOLTIP
.tooltip {
  position: relative;
  cursor: pointer;
  color: #1E78B4;
  line-height: 1.3em;

  &::after, &::before {
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    top: 1.7em;
    left: 50%;
    width: 15px;
    height: 15px;
    transform: translate(-50%, -50%) rotateZ(45deg);
    background-color: $brand-dark-blue;
    opacity: 0;
    transition: .3s all;

    @include media($bp-desktop-s) {
      display: none;
    }
  }
  &::before {
    z-index: 100;
    content: attr(tooltip);
    background-color: $brand-dark-blue;
    color: white;
    position: absolute;
    top: 1.7em;
    left: 50%;
    transform: translate(-50%, 0%);
    min-width: 300px;
    padding: 5px 11px 8px;
    opacity: 0;
    transition: .3s all;
    
    @include media($bp-desktop-s) {
      @include center-in-parent;
      position: fixed;
    }
  }

  @include media($bp-desktop-s) {
    &.clicked {
      &::before, &::after {
        opacity: 1;
        transition: .3s all;
      }
    }
  }

  &:hover {
    &::before, &::after {
      opacity: 1;
      transition: .3s all;
    }
  }
}
</style>
